export class PpeEquipment {
    id: number;
    name: string;
}

